import { Action } from 'redux';

import { COUNTS_DECREMENT } from '../../constants/actionTypes';
import { IFavoriteCountsSchema } from '../../repositories/favorites/entities/favorite_counts/FavoriteCountsSchema';
import { EEntityType, EDealType } from '../../types/filters';

export type TDecrementCount = 'counts/decrement';
export type TSetCounts = 'counts/set_user_favorites_count';

export interface IDecrementCount extends Action<TDecrementCount> {
  type: TDecrementCount;
  dealType: EDealType;
  entityType: EEntityType | null;
}

export interface ISetCounts extends Action<TSetCounts> {
  type: TSetCounts;
  data: IFavoriteCountsSchema;
}

export type TCountsActions = IDecrementCount | ISetCounts;

export function decrementCount(dealType: EDealType, entityType: EEntityType) {
  return {
    type: COUNTS_DECREMENT,
    dealType,
    entityType,
  };
}
